export default __webpack_public_path__ + "static/media/ketopopcorn@3x.f6d5cb06.jpg";